export const languageOptions = [
    { label: 'None', value: '' },
    { label: 'German (Germany)', value: 'de-DE' },
    { label: 'Spanish (Spain)', value: 'es-ES' },
    { label: 'Italian (Italy)', value: 'it-IT' },
    { label: 'French (France)', value: 'fr-FR' },
    { label: 'Hebrew (Israel)', value: 'iw-IL' },
    { label: 'Portuguese (Brazil)', value: 'pt-BR' },
    {
        label: 'Chinese, Mandarin (Simplified, China)',
        value: 'zh'
    }
]

export const userPrimaryLangOptions = [
    { label: 'American English', value: 'en-US' },
    { label: 'Australian English', value: 'en-AU' },
    { label: 'British English', value: 'en-GB' },
    { label: 'Canadian English', value: 'en-CA' },
    { label: 'Indian English', value: 'en-IN' },
    { label: 'Irish English', value: 'en-IE' },
    { label: 'South Africa English', value: 'en-ZA' }
]

export const userSecondaryLangOptions = [
    { label: 'None', value: 'none' },
    {
        label: 'Chinese, Mandarin (Simplified, China)',
        value: 'zh'
    },
    { label: 'French (France)', value: 'fr-FR' },
    { label: 'German (Germany)', value: 'de-DE' },
    { label: 'Hebrew (Israel)', value: 'iw-IL' },
    { label: 'Italian (Italy)', value: 'it-IT' },
    { label: 'Portuguese (Brazil)', value: 'pt-BR' },
    { label: 'Spanish (Spain)', value: 'es-ES' }
]

export const labelCodes = [
    { label: 'German (DE)', value: 'de-DE' },
    { label: 'Spanish (ES)', value: 'es-ES' },
    { label: 'Italian (IT)', value: 'it-IT' },
    { label: 'French (FR)', value: 'fr-FR' },
    { label: 'Hebrew (IL)', value: 'iw-IL' },
    { label: 'Portuguese (BR)', value: 'pt-BR' },
    { label: 'English (US)', value: 'en-US' },
    { label: 'English (AU)', value: 'en-AU' },
    { label: 'English (UK)', value: 'en-GB' },
    { label: 'English (CA)', value: 'en-CA' },
    { label: 'English (IN)', value: 'en-IN' },
    { label: 'English (IE)', value: 'en-IE' },
    { label: 'English (ZA)', value: 'en-ZA' },
    {
        label: 'Chinese, Mandarin (Simplified, China)',
        value: 'zh'
    }
]

export const getLabelFromCode = (code: string) => {
    return labelCodes.find(option => option.value === code)?.label || code
}
